import { type SagaIterator } from "@redux-saga/core";
import { call, put, takeEvery } from "redux-saga/effects";
import getLabelCatalog from "../../services/labelCatalog/labelCatalog.api";
import { type LabelCatalog } from "../../types/labelCatalog";
import { labelCatalogActions } from "./slice";
import { PayloadAction } from "@reduxjs/toolkit";

export function* onGetLabelCatalog(
  action: PayloadAction<string[]>
): SagaIterator {
  try {
    yield put(labelCatalogActions.fetchAllisLoading());
    const partNumbers = action.payload;
    const labelCatalogs: LabelCatalog[] = yield call(
      getLabelCatalog,
      partNumbers
    );
    yield put(labelCatalogActions.fetchAllSucceeded(labelCatalogs));
  } catch (e: unknown) {
    if (e instanceof Error) {
      yield put(labelCatalogActions.fetchAllFailure(e.message.toString()));
    }
  }
}

// Watcher Saga
function* labelCatalogWatcherSaga(): SagaIterator {
  yield takeEvery(labelCatalogActions.fetchAll.type, onGetLabelCatalog);
}

export default labelCatalogWatcherSaga;
